import { render, staticRenderFns } from "./ProjectTemplateLeft.vue?vue&type=template&id=5d0d3a1e&scoped=true"
import script from "./ProjectTemplateLeft.vue?vue&type=script&lang=js"
export * from "./ProjectTemplateLeft.vue?vue&type=script&lang=js"
import style0 from "./ProjectTemplateLeft.vue?vue&type=style&index=0&id=5d0d3a1e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0d3a1e",
  null
  
)

export default component.exports